<template lang="pug">
.feedback-container(v-if="show")
  .feedback-block
    .bottom-block
      .textarea-block
        .text.area
          .title 您对会员权益有什么建议吗？
          .close-btn(@click="closeModal")
            img(
              src="https://m.hellobike.com/resource/gallery/61/73dAyf7YZC.png?x-oss-process=image/quality,q_80"
            )
        textarea.textarea(
          ref="textarea",
          v-model.trim="feedbackValue",
          maxlength="200",
          contenteditable="plaintext-only",
          placeholder="您期望会员中添加哪些权益，您的建议是我们前进的动力"
        )
        .text-count-block
          span(:class="feedbackLength > 0 ? 'count' : ''") {{ feedbackLength }}
          span /200
      .submit-button(@click="clickSubmit" :class="feedbackValue !== '' ? '' : 'grey-submit'") 立即提交
  .shadow(@click="closeModal")
</template>
<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';

export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      feedbackValue: '',
      point: null,
      loadingPay: false,
    };
  },
  computed: {
    feedbackLength() {
      return this.feedbackValue.length || 0;
    },
  },
  created() {
    UBT.moduleExpose({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      moduleId: 'platform_VIP_NPS_submit',
      contentId: 'platform_VIP_NPS_submit',
      exposureTimes: 1,
      businessInfo: {},
    });
    const value = window.sessionStorage.getItem('history-word');
    this.feedbackValue = value || '';
  },
  mounted() {
  },
  methods: {
    clickSubmit() {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_VIP_NPS_submit',
        categoryId: 'platform',
        businessInfo: {},
      });
      window.sessionStorage.setItem('history-word', '');
      if (this.feedbackValue.length > 0) {
        this.$emit('submit', this.point, this.feedbackValue);
      }
    },
    closeModal() {
      window.sessionStorage.setItem('history-word', this.feedbackValue);
      this.$emit('close');
      this.$emit('update:show', false);
    },
  },
};
</script>
<style lang="less" scoped>
.feedback-container {
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;

  .feedback-block {
    position: fixed;
    bottom: 0;
    z-index: 222;
    height: 2.93rem;
    width: 100%;
    background-color: #fff;
    border-radius: 0.12rem 0.12rem 0.02rem 0.02rem;
    color: #242729;
    padding: 0.18rem 0.16rem 0 0.16rem;

    .bottom-block {
      width: 100%;
      height: 3.52rem;

      .textarea-block {
        margin-bottom: 0.24rem;
        position: relative;
        height: 1.42rem;

        img {
          width: 0.21rem;
          height: 0.2rem;
        }

        .area {
          display: flex;
          justify-content: space-between;
          margin-bottom: 0.16rem;

          .title {
            font-size: 0.16rem;
            font-weight: 500;
          }
        }

        .textarea {
          padding: 0.12rem 0.12rem;
          height: 1.12rem;
          resize: none;
          width: 100%;
          border-radius: 0.08rem;
          font-size: 0.14rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          background: #f3f5f7;
        }

        ::-webkit-input-placeholder {
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #bcc4cb;
        }

        .text-count-block {
          position: absolute;
          bottom: 0;
          right: 0.12rem;
          height: 0.17rem;
          line-height: 0.17rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #bcc4cb;
          font-size: 0.12rem;
        }
      }

      .submit-button {
        font-weight: 500;
        font-size: 0.18rem;
        color: #fff;
        line-height: 0.48rem;
        text-align: center;
        width: 100%;
        height: 0.48rem;
        background: #08f;
        border-radius: 0.08rem;
      }

      .grey-submit {
        background: #bcc4cc;
        box-shadow: 0 0.01rem 0.08rem 0 rgba(188, 196, 204, 0.4);
      }

      .text {
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
      }
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 220;
  }
}
</style>
